


































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'

import userList from '@/store/entities/userinfo'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';
class Packed {
    inputSackNums: number=0;
    inputBaseSkuNums: number = 0;
    warehouseReMark: string;
}
@Component
export default class EditLogisticsModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    selectuser: userList = new userList();
    user: Array<userList> = [];
    automaticJump: boolean;
    PackedModel: Packed = new Packed();
    site: number;
    packageWeightLimit: string;
    packageSize: string;
    isDisplay: boolean;
    created() {
        this.enterSearch();
        this.get();
    }
    async get() {
      
        this.user = await this.$store.dispatch({
            type: 'user/getUserList',
            data: {}
        });
        if (this.user.length > 0) {
            var data = this.user.filter(function (item) { return item.id == abp.session.userId });
          
            if (data.length > 0) {
                this.selectuser.id = data[0].id;
            }
          //  this.selectuser.id = this.user[0].id;
        }
       
    }

    //回车搜索
    enterSearch() {
        var _this = this;
        document.onkeydown = e => {
            //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
            if (e.keyCode === 13 && _this.isDisplay) {
                //回车后执行搜索方法
                _this.check();
            }
        }
    }


    async checks() {
        var _this = this;
        if (this.site == 8) {
            _this.$Modal.confirm({
                title: "是否打包", content: "巴西站要求：单边不超0.6m，三边不超0.9m，重量不超5kg", width: 700, onOk: () => {
                    _this.check();
                }
            });
        }
        else if (this.site == 9) {
            _this.$Modal.confirm({
                title: "是否打包", content: "墨西哥站要求：三边之和不超过2米，单边不超过1.05米,重量不超过2kg", width: 700, onOk: () => {
                    _this.check();
                }
            });
        }
        else if (this.site == 10) {
            _this.$Modal.confirm({
                title: "是否打包", content: "智利站要求： 三边之和不超过2米，单边不超过1.15米,重量不超过2kg", width: 700, onOk: () => {
                    _this.check();
                }
            });
        }
        else if (this.site == 11) {
            _this.$Modal.confirm({
                title: "是否打包", content: "哥伦比亚站要求：任意一边<1.05CM，重量不超过2kg", width: 700, onOk: () => {
                    _this.check();
                }
            });
        }
        else if (this.site == 12) {
            _this.$Modal.confirm({
                title: "是否打包", content: "波兰站：派送到门的包裹尺寸限制：长*宽*高不超过 60*50*40CM，派送至快递柜的包裹尺寸限制：长*宽*高不超过 64*38*41CM哥伦比亚：任意一边<1.05CM，重量不超过2kg", width: 700, onOk: () => {
                    _this.check();
                }
            });
        } else {
            _this.check();
        }
    }
    async check() {
        var ordertype = this.$store.state.backorder.ordertype;
        this.automaticJump = this.$store.state.backorder.automaticJump;
        var abnormalOrderList = this.$store.state.backorder.abnormalOrderList;
        
        if (ordertype == 0) {
            var orderNumber: string[] = [];
            for (var i = 0; i < abnormalOrderList.length; i++) {
                if (abnormalOrderList[i].abnormalUserId != this.selectuser.id) {
                    orderNumber.push(abnormalOrderList[i].orderNumber);
                }
            }
            var _this = this;
            if (orderNumber.length > 0) {
                _this.$Modal.confirm({
                    title: "是否打包", content: "订单编号为【" + orderNumber + "】,标记异常业务员非现在打包业务员，是否继续标为已打包？", width: 800, onOk: () => {
                        _this.save();
                    }
                });
            }
            else {
               this.save();
            }
        } else {
            this.save();
        }
    }


    async save() {
        var ordertype = this.$store.state.backorder.ordertype;
        var abnormalOrderList = this.$store.state.backorder.abnormalOrderList;
        if (ordertype == 0) {
            var ids = this.$store.state.backorder.ids;

            await this.$store.dispatch({
                type: 'backorder/updatePackedStatus',
                data: { ids: ids, SackNums: this.PackedModel.inputSackNums, BaseSkuNums: this.PackedModel.inputBaseSkuNums, packedUserId: this.selectuser.id, warehouseReMark: this.PackedModel.warehouseReMark }
            });
            var timestamp1 = (new Date()).valueOf().toString();
            if (this.automaticJump) {
                //this.$Modal.success({ title: "打包成功", content: "即将跳转到【快递单号入库页面】！" });
                this.$router.push({ name: 'intoLogistics', params: { JumpPage: timestamp1 } });
            }
        }
        else {
            var ids = this.$store.state.backmainlandorder.ids;
            await this.$store.dispatch({
                type: 'backmainlandorder/updatePackedStatus',
                data: { ids: ids, SackNums: this.PackedModel.inputSackNums, BaseSkuNums: this.PackedModel.inputBaseSkuNums, packedUserId: this.selectuser.id }
            });
        }

        (this.$refs.packForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }


    cancel() {
        (this.$refs.packForm as any).resetFields();
        this.$emit('input', false);
    }

    visibleChange(value: boolean) {
        this.isDisplay = value;
        if (!value) {
            this.$emit('input', value);
            
        } else {
            this.PackedModel.inputBaseSkuNums = this.$store.state.backorder.BaseSkuNums;
            this.site = this.$store.state.backorder.site;
                
        }
    }
}
